import React, { useState, useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Header.css";
import { validateToken } from "../pages/ValidateToken";
import axios from "axios";
import config from "../config/config.json";
// import uraddLogo from "../assets/uradd.jpg"; // 👈 add your logo (adjust path if needed)

const uraddLogo = "/img/uradd.jpg"

const navitems = [
  { text: "Utah At a Glance", to: "/utah-at-a-glance" },
  { text: "Utah Key Economic Verticals", to: "/verticals" },
  { text: "Utah Gallery", to: "/gallery" },
  { text: "Search", to: "/search" },
  { text: "Contact Us", to: "/contact-us" },
  { text: "About UTahData.org", to: "/about-us" },
];

const UraddHeader = ({ scrollContainerRef }) => {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const [user, setUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [validToken, setValidToken] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleNavigate = () => navigate("/profile");
  const handleClick = () => navigate("/");

  const goto = useCallback(
    (to) => {
      navigate(to);
      setIsMenuOpen(false);
    },
    [navigate]
  );

  // Fetch auth status
  useEffect(() => {
    axios
      .get("https://utsb.utahdata.org/bdxbackend/auth/me", {
        withCredentials: true,
      })
      .then(({ data }) => {
        if (data.authenticated) {
          setValidToken(true);
          setUser(data.user);
        } else {
          setUser(null);
        }
      })
      .catch(() => setUser(null));
  }, []);

  // Scroll listener
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Scroll listener for custom container
  useEffect(() => {
    const scrollElement = scrollContainerRef?.current;
    if (!scrollElement) return;
    const onScroll = () => {
      setScrolled(scrollElement.scrollTop > 10);
    };
    scrollElement.addEventListener("scroll", onScroll);
    return () => scrollElement.removeEventListener("scroll", onScroll);
  }, [scrollContainerRef]);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen(!isDropdownOpen);
  };

  // Validate token
  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setValidToken(false);
        return;
      }
      const { valid } = await validateToken(token);
      if (!valid) {
        setValidToken(false);
        return;
      }
      setValidToken(true);
    };
    checkToken();
  }, []);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    axios
      .post(config.APP_URL + "/utahdata/logout", {}, { withCredentials: true })
      .then(() => {
        setUser(null);
        window.location.href = "https://utahdata.org/login";
      })
      .catch((err) => console.error("Logout error:", err));
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div>
      {/* <header
        className={`header ${scrolled ? "scrolled" : ""} z-[1400] flex items-center justify-between`}
      >
      
        <img
          src="/img/headerlogo.png"
          alt="Utah Data Logo"
          className="logo cursor-pointer"
          onClick={handleClick}
        />

      
        <div className="flex flex-col items-center justify-center flex-1 text-center">
  <div>
    <img
      src={uraddLogo}
      alt="Center Logo"
      className="h-14 w-auto cursor-pointer"
      onClick={handleClick}
    />
  </div>
  <div>
    <span className="text-sm text-black sm:text-base font-semibold">
      Utah Registry of Autism and Developmental Disabilities (URADD)
    </span>
    
  </div>
  <div>
    <span className="text-sm text-blue-700 sm:text-base font-semibold">
      Data for this page was provided by URADD
    </span>
  </div>
</div>


      
        <div className="flex flex-row gap-3">
          {validToken ? (
            <div className="flex gap-2 shadow-2xl text-base no-underline px-2 py-1 bg-white opacity-80 rounded-lg">
              <div className="relative" ref={dropdownRef}>
                <a className="no-underline" onClick={toggleDropdown}>
                  <span className="text-green-900 shadow-2xl text-base no-underline">
                    Hi {username?.name}
                  </span>
                  <img
                    src="/img/login1.png"
                    className="h-6 w-auto"
                    alt="Login"
                  />
                </a>

                {isDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-40 shadow-lg rounded-lg bg-white">
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded-lg"
                    >
                      Logout
                    </button>
                    <button
                      onClick={handleNavigate}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded-lg"
                    >
                      User Profile
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : null}

          <div
            className="menu"
            onClick={() => setIsMenuOpen(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setIsMenuOpen(true)}
          >
            <div>☰ MENU</div>
          </div>
        </div>
      </header> */}

      <header
  // className={`header ${scrolled ? "scrolled" : ""} z-[1400] flex flex-col sm:flex-row items-center justify-between px-3 py-2 gap-2`}
   className={`header ${scrolled ? "scrolled" : ""} z-[1400] flex flex-col sm:flex-row items-center justify-between`}
>
  {/* Left logo */}
  <img
    src="/img/headerlogo.png"
    alt="Utah Data Logo"
    className="h-10 w-auto cursor-pointer sm:h-12"
    onClick={handleClick}
  />

  {/* Center logo + text (stacked on small, inline on medium+) */}
  <div className="flex flex-col items-center justify-center flex-1 text-center px-2">
    <img
      src={uraddLogo}
      alt="Center Logo"
      className="h-10 sm:h-14 w-auto "
      
    />
    <span className="block text-xs sm:text-sm md:text-base font-semibold text-black mt-1">
      Utah Registry of Autism and Developmental Disabilities (URADD)
    </span>
    <span className="block text-xs sm:text-sm md:text-base font-semibold text-blue-700 mt-0.5">
      Data for this page was provided by URADD
    </span>
  </div>

  {/* Right side */}
  <div className="flex flex-row items-center gap-2 sm:gap-3">
    {validToken && (
      <div className="flex gap-2 text-sm sm:text-base no-underline px-2 py-1 bg-white/80 rounded-lg shadow-lg">
        <div className="relative" ref={dropdownRef}>
          <a className="no-underline cursor-pointer" onClick={toggleDropdown}>
            <span className="text-green-900">Hi {username}</span>
            <img src="/img/login1.png" className="h-6 w-auto inline-block ml-1" alt="Login" />
          </a>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-36 sm:w-40 shadow-lg rounded-lg bg-white">
              <button
                onClick={handleLogout}
                className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded-lg"
              >
                Logout
              </button>
              <button
                onClick={handleNavigate}
                className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded-lg"
              >
                User Profile
              </button>
            </div>
          )}
        </div>
      </div>
    )}

    {/* Hamburger menu */}
    {/* <div
      className="menu text-base sm:text-lg font-semibold cursor-pointer"
      onClick={() => setIsMenuOpen(true)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && setIsMenuOpen(true)}
    >
      ☰ MENU
    </div> */}
      <div
            className="menu"
            onClick={() => setIsMenuOpen(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setIsMenuOpen(true)}
          >
            <div>☰ MENU</div>
          </div>
  </div>
</header>


      {/* Overlay menu */}
      <div className={`menu-overlay ${isMenuOpen ? "open" : ""}`}>
        <div className="menu-header">
          <div className="menu">☰ MENU</div>
          <span
            className="close-button"
            onClick={() => setIsMenuOpen(false)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setIsMenuOpen(false)}
          >
            X CLOSE
          </span>
        </div>

        <div className="menu-header-underline"></div>

        <div className="menu-overlay-inner">
          <div className="menu-content">
            <ul>
              {navitems.map((item, index) => (
                <li onClick={() => goto(item.to)} key={index}>
                  <span className="hover-bracket-wrapper">
                    <span className="text">{item.text}</span>
                    <span className="underline"></span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="header-background-image" />
        </div>

        <div className="menu-footer">
          <div className="menu-footer-left">©2025 UTahData.org</div>
          <div className="menu-footer-right">
            <div>
              <h4>MAIL</h4>
              <a href="mailto:bodex@bodex.io?subject=Interested%20in%20UtahData.org&body=I'm%20interested%20to%20learn%20more%20about%20UtahData.org.%20Please%20share%20more%20details.">
                bodex@bodex.io
              </a>
            </div>
            <div>
              <h4>SOCIAL</h4>
              <div className="menu-footer-social">
                <a href="https://www.facebook.com/profile.php?id=61571797313046">
                  Facebook
                </a>
                <span>|</span>
                <a href="https://www.linkedin.com/company/utahdata/">
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UraddHeader;
